import axios from "axios";

export const getCtrStatus = () =>
  axios
    .get(`${window.CONFIG.ctrStatusUrl}/status.json`, {
      headers: null
    })
    .then((resp) => resp.data);
